import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useStyles = makeStyles((theme: Theme) => createStyles({
  apartmentIconInfo: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '& > div:not(:last-child)': {},
    '& > div': {
      width: '50%',
      marginBottom: '2px',
      overflow: 'hidden',
      overflowWrap: 'anywhere',
      '& > img': {
        marginRight: '4px',
        width: '24px',
        height: '24px',
        [theme.breakpoints.up('xl')]: {
          width: '28px',
          height: '28px',
        },
      },
    },
  },
  iconInfo: {
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    '& .iconInfoText': {
      lineHeight: '14px',
      [theme.breakpoints.up('xl')]: {
        fontSize: '14px',
      },
    },
  },
}));
